import React, { useState, useEffect } from "react";
import { ButtonStyle } from './UIElements/Buttons/ButtonStyle';
import { useHistory } from "react-router-dom";
import authservice from "./Authentication/service/authservice";

const ShowPopup = ({ visible, onClose }) => {
    const history = useHistory();
    // const navigate = useNavigate();

    // useEffect(() => {
    //     const hasSeenPopup = sessionStorage.getItem("hasSeenDiwaliPopup");
    //     if (!hasSeenPopup) {
    //         setIsPopupVisible(true);
    //         sessionStorage.setItem("hasSeenDiwaliPopup", "true");
    //     }
    // }, []);

    // const closePopup = () => {
    //     setIsPopupVisible(false);
    // };

    if (!visible) return null;

    return (
        <div className="diwali-popup-overlay">
            <div className="diwali-popup">
                <span className="close-icon" onClick={onClose}>×</span>
                {/* Fireworks elements */}
                {/* <div className="firework firework1"></div>
                <div className="firework firework2"></div>
                <div className="firework firework3"></div> */}
                <div className="row">
                    {/* <div className="col-md-4 col-4 diya"></div> */}
                    <div className="col-md-12 col-12">
                        <h2 className="diwali-message text-center">Dear AajuBaajuian!</h2>
                        <p className="diwali-submessage text-center">New Order Received in your AajuBaaju Mart.</p>
                        <ButtonStyle type="button" handleClick={() => history.push(`/mart/${authservice.getCurrentUserName()}`)}><span onClick={onClose}>Order </span></ButtonStyle>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShowPopup;
